export const DEFAULT_TEMPLATE_VARIABLES = [
  'client_first_name',
  'client_last_name',
  'policy_number',
  'amount',
  'due_date',
  'agent_name',
]

export const BOTMAKER_VARIABLES = [
  'userName',
  'firstName',
  'lastName',
  'phoneNumber',
  'custom',
]



